import { createApp } from 'vue'
import BlogListing from './components/blog-listing.vue';
import BalanceTransferCalculator from './components/balance-transfer-calculator.vue';

/**
 * Creates a Vue instance for each element matching the selector.
 * @param {string} selector - CSS selector
 * @param {Object} options - Vue instance options
 * @param {function} setup - Optional setup function to execute on Vue instance
 */
function createVueInstance(selector, options, setup) {
  const elements = Array.from(document.querySelectorAll(selector))
  elements.forEach(element => {
    const app = createApp(options)
    app.config.globalProperties.window = window

    if (setup) {
      setup(app)
    }

    app.mount(element)
  });
}

createVueInstance('#blogListing', {
  components: { BlogListing },
});

createVueInstance('#balanceTransferCalculator', {
  components: { BalanceTransferCalculator },
  template: '<BalanceTransferCalculator />' // Not aligned with bloglisting so need this
});
